import { FetchAction } from '../../types/types';
import { AnalyticsState } from './types';
import { SORT_MODELS } from 'src/actions/actionTypes';

export const initialState: AnalyticsState = {
  productSorted: '',
  sortAsc: false,
  sortType: '',
};

export default function analyticsReducer(
  state = initialState,
  action: FetchAction,
) {
  if (action.type === SORT_MODELS) {
    return {
      ...state,
      productSorted: action.productSorted,
      sortAsc: action.sortAsc,
      sortType: action.sortType,
    };
  }

  return state;
}
